import store from '@/store'
import request from '@/assets/js/utils/request'

export function oAuth(data){
  return request({
    url: 'AppClient/OAuth/OAuth2',
    method: 'post',
    data
  })
}

export function setUser(str) {
  sessionStorage.setItem('wx-user', str)
  let data  =JSON.parse(str)
  store.commit('user/SET_USER_INFO', data)
  store.commit('user/SET_TOKEN', data.token)
}

export function getCode() {
  let url = window.location.href
  if (url.indexOf("?") != -1) { 
    let str = url.substr(1)
    let strs = str.split("=")
    return strs[1]
  }
}


export function oAuthIdentity(data){
  return request({
    url: 'AppClient/OAuth/OAuth',
    method: 'post',
    data
  })
}

export function yzm(data){
  return request({
    url: 'AppClient/OAuth/yzm',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/utils/auth.js